var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"nonzero","d":"M15.82 14.94l-3.9-3.9a6.74 6.74 0 10-.88.88l3.9 3.9a.62.62 0 00.88 0 .62.62 0 000-.88zM1.24 6.74a5.5 5.5 0 1111 0 5.5 5.5 0 01-11 0z"}));
}

Search.defaultProps = {"width":"16","height":"16","fill":"#494848","viewBox":"0 0 16 16"};

module.exports = Search;

Search.default = Search;
